import sha256 from 'crypto-js/sha256';
import { GetHashDoubleParamsType } from './types';

export class Hasher {
  static getHashDoubleForMEGroup(
    visitorIdentifier: string,
    meGroupName: string,
  ): number {
    return this.calculateHash(visitorIdentifier + meGroupName);
  }

  static getHashDouble({
    visitorIdentifier,
    id,
    respoolTime,
  }: GetHashDoubleParamsType): number {
    let suffix = '';

    if (respoolTime) {
      suffix += String(respoolTime);
    }

    return this.calculateHash(visitorIdentifier + id + suffix);
  }

  // --- Note ---
  // `hashDouble` is a seeded pseudo-random number between 0 and 1
  // used for deciding what variation to assign
  // `calculateHash` algorithm is consistent between every SDK
  // and will always provide same pseudo-random value for the same input parameters
  static calculateHash(seed: string): number {
    const hashDigest = sha256(seed).toString();

    return parseInt(hashDigest, 16) / Math.pow(2, 256);
  }
}
